import { run } from 'vanilla-cookieconsent';

const configDefaults = {
    title: 'Aviso de Cookies',
    description: 'Utilizamos cookies propias y de terceros para mejorar tu experiencia de navegación y analizar el tráfico de la web.',
    info_title: 'Más información',
    info_description: 'Revise nuestra política de privacidad y cookies.',
    privacyUrl: '#'
};

// Fusionar window.cookieConfig con los valores por defecto
const currentCookieConfig = window.cookieConfig || configDefaults;

// Función auxiliar para actualizar Google Consent Mode v2
const updateGoogleConsent = (status) => {
    if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
            'ad_storage': status,
            'ad_user_data': status,
            'ad_personalization': status,
            'analytics_storage': status
        });

        if (status === 'granted') {
            window.dataLayer.push({ 'event': 'cookie_consent_analytics' });
        }
    }
};

export const initCookies = () => {
    run({
        // Configuración de interfaz (v3.1.0 usa guiOptions)
        guiOptions: {
            consentModal: {
                layout: 'box inline',
                position: 'bottom right',
                equalWeightButtons: true,
                flipButtons: false
            },
            preferencesModal: {
                layout: 'box',
                position: 'right',
                equalWeightButtons: true,
                flipButtons: false,
            }
        },

        // Definición de categorías
        categories: {
            necessary: {
                readOnly: true,
                enabled: true
            },
            analytics: {
                enabled: false,
                // Auto-clear cookies si el usuario rechaza después de haber aceptado
                autoClear: {
                    cookies: [
                        { name: /^(_ga|_gid)/ } // Borra cookies de Google Analytics
                    ]
                }
            }
        },

        // Eventos (Hooks de la v3.1.0)
        onConsent: ({ cookie }) => {
            if (cookie.categories.includes('analytics')) {
                updateGoogleConsent('granted');
            }
        },

        onChange: ({ changedCategories }) => {
            if (changedCategories.includes('analytics')) {
                const status = isCategoryAccepted('analytics') ? 'granted' : 'denied';
                updateGoogleConsent(status);
            }
        },

        onModalReady: ({modalName, modal}) => {
            if (modalName === 'preferencesModal') {
                modal.querySelector('.pm__body')?.setAttribute('data-lenis-prevent', '');
            }
        },

        language: {
            default: 'es',
            translations: {
                es: {
                    consentModal: {
                        title: currentCookieConfig.title,
                        description: currentCookieConfig.description,
                        acceptAllBtn: 'Aceptar todas',
                        acceptNecessaryBtn: 'Solo necesarias',
                        showPreferencesBtn: 'Gestionar preferencias',
                        footer: `<a href="${currentCookieConfig.privacyUrl}">Política de Privacidad</a>`
                    },
                    preferencesModal: {
                        title: 'Configuración de cookies',
                        saveSettingsBtn: 'Guardar ajustes',
                        acceptAllBtn: 'Aceptar todas',
                        rejectAllBtn: 'Rechazar todas',
                        closeIconLabel: 'Cerrar',
                        serviceCounterLabel: 'Servicios',
                        sections: [
                            {
                                title: 'Uso de cookies',
                                description: 'Utilizamos cookies para garantizar las funcionalidades básicas del sitio web y mejorar tu experiencia en línea.',
                            },
                            {
                                title: 'Cookies técnicas',
                                description: 'Estas cookies son esenciales para el correcto funcionamiento del sitio web, por ejemplo, para la autenticación del usuario.',
                                linkedCategory: 'necessary'
                            },
                            {
                                title: 'Cookies de Analítica',
                                description: 'Las cookies utilizadas para analítica ayudan a recopilar datos que permiten a los servicios comprender cómo interactúan los usuarios con ellos. Esta información permite mejorar el contenido y desarrollar mejores funcionalidades que optimicen la experiencia del usuario.',
                                linkedCategory: 'analytics',
                                cookieTable: {
                                    headers: {
                                        name: 'Nombre',
                                        domain: 'Servicio',
                                        description: 'Descripción',
                                        expiration: 'Caducidad',
                                    },
                                    body: [
                                        {
                                            name: '_ga',
                                            domain: 'Google Analytics',
                                            description: 'Cookie establecida por <a href="https://business.safety.google/adscookies/" target="_blank">Google Analytics</a> para rastrear el comportamiento del usuario.',
                                            expiration: 'Caduca después de 12 meses',
                                        },
                                        {
                                            name: '_gid',
                                            domain: 'Google Analytics',
                                            description: 'Cookie establecida por <a href="https://business.safety.google/adscookies/" target="_blank">Google Analytics</a> para distinguir a los usuarios.',
                                            expiration: 'Caduca después de 24 horas',
                                        },
                                    ],
                                },
                            },
                            {
                                title: currentCookieConfig.info_title,
                                description: currentCookieConfig.info_description,
                            }
                        ]
                    }
                }
            }
        }
    });
};
